import { Box, tabNavigationStyle, Text, theme } from '@lojinha/design-system'
import { testId } from '@lojinha/helpers'
import React, { FC } from 'react'
import styled from 'styled-components'
import { t } from '../../dictionary'

export const Wrapper = styled.div`
  width: ${theme.space.x48};
  height: ${theme.space.x48};
  display: flex;
  flex-direction: column;
  ${tabNavigationStyle};
`
export enum DayCalendarVariants {
  info = 'info',
  primary = 'primary',
  secondary = 'secondary',
  alert = 'alert',
  error = 'error',
}

const dayCalendarStyles: Record<
  DayCalendarVariants,
  { backgroundColor: string; fontColor: keyof typeof theme.colors }
> = {
  [DayCalendarVariants.info]: {
    backgroundColor: theme.colors.gray700,
    fontColor: 'gray700',
  },
  [DayCalendarVariants.primary]: {
    backgroundColor: theme.colors.blueberryDark,
    fontColor: 'blueberryDark',
  },
  [DayCalendarVariants.secondary]: {
    backgroundColor: theme.colors.acaiDark,
    fontColor: 'acaiDark',
  },
  [DayCalendarVariants.alert]: {
    backgroundColor: theme.colors.alert,
    fontColor: 'alert',
  },
  [DayCalendarVariants.error]: {
    backgroundColor: theme.colors.error,
    fontColor: 'error',
  },
}

type DayCalendarProps = {
  dayNumber: number
  month?: string
  variant?: DayCalendarVariants
  tabindex?: number
}

export const DayCalendar: FC<DayCalendarProps> = ({
  dayNumber,
  month,
  variant = DayCalendarVariants.primary,
  tabindex,
}) => {
  if (dayNumber < 1 || dayNumber > 31) return null

  return (
    <Wrapper
      aria-label={t.date.dayCalendarAriaLabel({ day: dayNumber, month })}
      tabIndex={tabindex ?? 0}
    >
      <Text
        isBold
        textSize="x1"
        textAlign="center"
        textTransform="uppercase"
        color="white"
        htmlAttrs={{
          style: {
            backgroundColor: dayCalendarStyles[variant].backgroundColor,
            borderTopLeftRadius: theme.borderRadius.x8,
            borderTopRightRadius: theme.borderRadius.x8,
            height: theme.space.x16,
            lineHeight: theme.lineHeights.x18,
          },
        }}
        {...testId(`day-calendar-day-number-header`)}
      >
        {month ?? t.day}
      </Text>

      <Box
        display="flex"
        flexGrow={1}
        borderColor="gray200"
        borderStyle="solid"
        borderWidth={1}
        borderTopWidth={0}
        htmlAttrs={{
          style: {
            borderBottomLeftRadius: theme.borderRadius.x8,
            borderBottomRightRadius: theme.borderRadius.x8,
          },
        }}
      >
        <Text
          isBold
          textSize="x2"
          textAlign="center"
          textTransform="uppercase"
          color={dayCalendarStyles[variant].fontColor}
          htmlAttrs={{
            style: {
              flexGrow: 3,
              alignItems: 'center',
              justifyContent: 'center',
              display: 'flex',
            },
          }}
          {...testId(`day-calendar-day-number`)}
        >
          {dayNumber}
        </Text>
      </Box>
    </Wrapper>
  )
}
